import React from "react"
import HeroSection from "../components/Hero"
import AboutUs from "../components/AboutUs"
import Services from "../components/Services"
import Team from "../components/Team"
import Clients from "../components/Clients"
import "./Home.css"
import Work from "../components/Work"

const Home = () => {
  return (
    <React.Fragment>
        <HeroSection />
        <AboutUs />
        <Services />
        <Team />
        <Clients />
        <Work />
    </React.Fragment>
  )
}

export default Home
